var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductBox3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3241_33919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 14.0995L11.25 6.31445",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 24.0008V12.0008C31.4995 11.4747 31.3606 10.958 31.0973 10.5026C30.834 10.0471 30.4556 9.66887 30 9.40583L19.5 3.40583C19.0439 3.14252 18.5266 3.00391 18 3.00391C17.4734 3.00391 16.9561 3.14252 16.5 3.40583L6 9.40583C5.54439 9.66887 5.16597 10.0471 4.90269 10.5026C4.63941 10.958 4.50054 11.4747 4.5 12.0008V24.0008C4.50054 24.5269 4.63941 25.0436 4.90269 25.4991C5.16597 25.9546 5.54439 26.3328 6 26.5958L16.5 32.5958C16.9561 32.8591 17.4734 32.9978 18 32.9978C18.5266 32.9978 19.0439 32.8591 19.5 32.5958L30 26.5958C30.4556 26.3328 30.834 25.9546 31.0973 25.4991C31.3606 25.0436 31.4995 24.5269 31.5 24.0008Z",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90503 10.4395L18 18.0145L31.095 10.4395",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 33.12V18",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3241_33919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBox3);
export default __webpack_public_path__ + "static/media/product-box-3.b886fcb03b4f8a13dcda5d335d8d2dfd.svg";
export { ForwardRef as ReactComponent };